module.exports = __webpack_public_path__ + "5fcac3468df66035c5c3b32881421bf3.mp4";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/value_of_technology_demo.mp4
// module id = 572
// module chunks = 0